angular.module("UI8.controllers").controller("HeaderController", [
  "$scope",
  "$rootScope",
  "$location",
  "$timeout",
  "PromoService",
  function () {
    const browse = document.querySelector(".header__cell--browse"),
      menuInner = document.querySelector(".menu__inner");

    const applyOverlayMask = (e) => {
      if (browse.classList.contains("active")) {
        const overlayEl = e.currentTarget;
        const x = e.clientX - menuInner.offsetLeft;
        const y = e.clientY - menuInner.offsetTop;

        overlayEl.style = `--opacity: 1; --x: ${x}px; --y:${y}px;`;
      }
    };

    document.body.addEventListener("pointermove", applyOverlayMask);

    // Mega menu 3D-Assets tile: removing a CSS animation snaps its
    // transform to rest. Track the animated frames of the card AND the
    // cube's inner parts while hovered (by mouseleave the :hover styles
    // are already gone), then on leave freeze each as an inline transform
    // and release — their transitions carry everything back together.
    const cube = document.querySelector("svg.mi--3d");
    if (cube) {
      const cubeTile = cube.closest("a");
      const parts = [cube].concat(
        Array.prototype.slice.call(
          cube.querySelectorAll(".mi__stem, .mi__arm-l, .mi__arm-r, .mi__dot")
        )
      );
      const frames = new Array(parts.length);
      let cubeRaf;

      cubeTile.addEventListener("mouseenter", () => {
        parts.forEach((el) => (el.style.animation = ""));
        const track = () => {
          for (let i = 0; i < parts.length; i++) {
            frames[i] = getComputedStyle(parts[i]).transform;
          }
          cubeRaf = requestAnimationFrame(track);
        };
        cubeRaf = requestAnimationFrame(track);
      });

      cubeTile.addEventListener("mouseleave", () => {
        cancelAnimationFrame(cubeRaf);
        parts.forEach((el, i) => {
          if (!frames[i] || frames[i] === "none") return;
          el.style.animation = "none";
          el.style.transition = "none"; // freeze must land instantly
          el.style.transform = frames[i];
        });
        // svg elements have no offsetWidth — flush via rect read
        void cube.getBoundingClientRect().width;
        parts.forEach((el) => {
          el.style.transition = "";
          el.style.transform = ""; // transitions carry it back from here
        });
      });
    }

    // const headAap20 = document.querySelector(".header__head--aap20");
    // if (headAap20) {
    //   headAap20.addEventListener("click", () => {
    //     PromoService.applyPromo("aap20").then((promo) => {
    //       UI8.promo = promo;
    //       var event = new Event("promo-updated");
    //       document.body.dispatchEvent(event);
    //     });
    //   });
    // }

    // const headAap40 = document.querySelector(".header__head--aap40");
    // if (headAap40) {
    //   headAap40.addEventListener("click", () => {
    //     PromoService.applyPromo("aap40").then((promo) => {
    //       UI8.promo = promo;
    //       var event = new Event("promo-updated");
    //       document.body.dispatchEvent(event);
    //     });
    //   });
    // }
  },
]);
